import * as React from "react"

export type UpgradePromptContextValue = {
  openUpgrade: (featureMessage: string) => void
  close: () => void
}

export const UpgradePromptContext = React.createContext<UpgradePromptContextValue | null>(null)

export function useUpgradePrompt(): UpgradePromptContextValue {
  const c = React.useContext(UpgradePromptContext)
  if (!c) {
    return {
      openUpgrade: () => {},
      close: () => {},
    }
  }
  return c
}
